// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const SUGEST_PRIOR = {
  Baixa: 'SUGEST_PRIOR1',
  Media: 'SUGEST_PRIOR2',
  Alta: 'SUGEST_PRIOR3',
  Critica: 'SUGEST_PRIOR4',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    SUGEST_PRIOR1: 1,
    SUGEST_PRIOR2: 2,
    SUGEST_PRIOR3: 3,
    SUGEST_PRIOR4: 4
  }
}
